import { render } from "./YoutubeIcon.vue?vue&type=template&id=10fd1e79"
const script = {}

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__